// Chat Messages Component
// Displays the chat message history

import { Loader2 } from 'lucide-react';

const ChatMessages = ({ messages, submitting, completed, messagesEndRef }) => {
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      {messages.map((msg, index) => (
        <div 
          key={index} 
          className={`chat-message flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div className={msg.type === 'user' ? 'chat-bubble-user px-4 py-2 shadow-sm' : 'chat-bubble-bot px-4 py-2 shadow-sm'}>
            {msg.text}
          </div>
        </div>
      ))}
      
      {/* Typing indicator */}
      {submitting && !completed && (
        <div className="flex justify-start">
          <div className="chat-bubble-bot px-4 py-3">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-slate-400 rounded-full typing-dot"></div>
              <div className="w-2 h-2 bg-slate-400 rounded-full typing-dot"></div>
              <div className="w-2 h-2 bg-slate-400 rounded-full typing-dot"></div>
            </div>
          </div>
        </div>
      )}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatMessages;
